import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import TextSearchAdapterType from '@jbrowse/core/pluggableElementTypes/TextSearchAdapterType';
import Plugin from '@jbrowse/core/Plugin';
import { AdapterClass as TrixTextSearchAdapterClass, configSchema as trixAdapterConfigSchema } from './TrixTextSearchAdapter';
var _default = /*#__PURE__*/function (_Plugin) {
  _inherits(_default, _Plugin);
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
    _this.name = 'TrixPlugin';
    return _this;
  }
  _createClass(_default, [{
    key: "install",
    value: function install(pluginManager) {
      pluginManager.addTextSearchAdapterType(function () {
        return new TextSearchAdapterType({
          name: 'TrixTextSearchAdapter',
          displayName: 'Trix text search adapter',
          configSchema: trixAdapterConfigSchema,
          AdapterClass: TrixTextSearchAdapterClass,
          description: 'Trix adapter'
        });
      });
    }
  }]);
  return _default;
}(Plugin);
export { _default as default };